__webpack_require__.p = "https://v.perm.ru/react-patterns/";